module.exports = __webpack_public_path__ + "img/footer-shape-3.f5965b6d.png";